import * as React from 'react';
import { MAX_CODE_LENGTH } from '../../../../utils/schema';
import { BaseInput } from '@components/molecules';

const FilterCharactersRegex = /^\d{1,6}$/;

type Props = Omit<React.ComponentProps<typeof BaseInput>, 'type'>;

export const CodeInput = (props: Props) => {
	const filterLetters = (e: InputEvent) => {
		const isDigits: boolean = FilterCharactersRegex.test(e.data || '');
		if (!isDigits) {
			e.preventDefault();
		}
	};

	return (
		<BaseInput
			{...props}
			type="text"
			maxLength={MAX_CODE_LENGTH}
			inputMode="numeric"
			pattern="[0-9]*"
			onBeforeInput={filterLetters as unknown as React.FormEventHandler<HTMLInputElement>}
		/>
	);
};
